import React from "react";
import { Col, Row } from "react-bootstrap";

import FeatureImage from "../../assets/images/Home/Features/app.png";

const Feature = () => {
  const features = [
    {
      title: "It reduces relationship overload.",
      description: "No more scattered notes, missed follow-ups, or forgotten details. Socius brings your relationship context into one calm, organized space.",
      id: 1,
    },
    {
      title: "It turns memory into action.",
      description: "AI summaries, decisions, deadlines, and reminders help you follow through with clarity instead of relying on mental checklists.",
      id: 2,
    },
    {
      title: "It works across personal and professional life.",
      description: "Use Socius for friends, family, mentors, clients, colleagues, stakeholders, projects, and events.",
      id: 3,
    },
    {
      title: "It puts privacy first.",
      description: "Your relationships are personal. Socius is built with data ownership, export options, consent controls, and secure handling at the center.",
      id: 4,
    },
  ];
  return (
    <>
      <div className="features-component container">
        <Row>
          <Col className="feature-image mt-5" xs={12} md={12} lg={6}>
            <img src={FeatureImage} alt="" />
          </Col>
          <Col className="feature-details mt-5" xs={12} md={12} lg={6}>
            <div className="content mt-1">
              {/* <h5>Features</h5> */}
              <h1>
                <span>Why Choose</span> Socius
              </h1>
              <div className="feature-list mt-5">
                {features.map((feature, index) => (
                  <div key={feature.id} className="feature-item mb-3">
                    <input
                      type="radio"
                      id={`feature${index}`}
                      disabled
                      checked={index % 2 === 0}
                    />
                    <label htmlFor={`feature${index}`}>
                      <h3>{feature.title}</h3>
                      <p className="mb-2">{feature.description}</p>
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
export { Feature };
